import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Attachment} from "../../../attachment-manager/attachment-manager.component";
import {CkmService} from "../../../../services/ckm.service";

@Component({
  selector: 'app-ckm-simulation-details',
  templateUrl: './ckm-simulation-details.component.html',
  styleUrls: ['./ckm-simulation-details.component.scss']
})
export class CkmSimulationDetailsComponent implements OnInit {
  @Input() simulation: any;

  simulationForm: FormGroup;
  attachments: Attachment[] = [];
  loading = false;
  isChanged = false;  // Flag per tracciare le modifiche
  private initialFormValue: string;  // Snapshot iniziale dei valori del form

  constructor(private _formBuilder: FormBuilder, private ckmService: CkmService) {}

  ngOnInit(): void {
    this.initForm();
    // Salva lo stato iniziale del form
    this.initialFormValue = JSON.stringify(this.simulationForm.value);
    // Sottoscrizione per monitorare le modifiche del form
    this.simulationForm.valueChanges.subscribe(val => {
      this.isChanged = JSON.stringify(val) !== this.initialFormValue;
    });
  }

  initForm(): void {
    const attachments = this.simulation?.attachment_pubmeds?.concat(this.simulation?.attachment_files) || [];
    this.simulationForm = this._formBuilder.group({
      name: [this.simulation?.name || '', Validators.required],
      description: [this.simulation?.description || ''],
      attachments: [attachments]
    });
    this.attachments = attachments;
  }

  onAttachmentsChange(updatedAttachments: Attachment[]): void {
    this.attachments = updatedAttachments;
    this.simulationForm.get('attachments')?.setValue(this.attachments);
  }

  onUpdate(): void {
    if (this.simulationForm.valid) {
      const updatedSimulation = {
        ...this.simulationForm.value
      };

      this.loading = true;
      this.ckmService.updateCkmSimulation(
        this.simulation.id,
        updatedSimulation,
        (response) => {
          this.loading = false;
          this.initialFormValue = JSON.stringify(this.simulationForm.value);
          this.isChanged = false;
        },
        (error) => {
          this.loading = false;
        }
      );
    }
  }

  /**
   * Resetta il form ai valori iniziali della simulazione.
   */
  resetForm(): void {
    const attachments = this.simulation?.attachment_pubmeds?.concat(this.simulation?.attachment_files) || [];
    this.simulationForm.reset({
      name: this.simulation?.name || '',
      description: this.simulation?.description || '',
      attachments
    });
    this.attachments = attachments;
    this.initialFormValue = JSON.stringify(this.simulationForm.value);
    this.isChanged = false;
  }
}
